import { Input } from "@/components/ui/input";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type FilterInputProps = {
    values: string[];
    setValues: (values: string[]) => void;
};

const FilterInput = ({ values, setValues }: FilterInputProps) => {
    const [newKeyword, setNewKeyword] = useState("");
    const { t } = useTranslation();

    return (
        <Input
            className="px-2"
            onChange={(e) => setNewKeyword(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter" && newKeyword) {
                    setValues?.(values?.concat(newKeyword));
                    setNewKeyword("");
                }
            }}
            placeholder={t("customViewDialog.viewConfig.writeHere")}
            value={newKeyword}
            variant="ghost"
        />
    );
};

export default FilterInput;
